import { useEffect, useRef, useState } from 'react'
import { FiLogOut } from 'react-icons/fi'
// require() forces CJS build — react-idle-timer v5 ESM (.mjs) fails strict resolution in CRA/Webpack 5
const { useIdleTimer } = require('react-idle-timer')
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import Modal from 'rsuite/Modal'
import * as auth from 'src/app/modules/auth'
import { RootState } from 'src/setup'

const IDLE_TIMEOUT_MS = 60 * 60 * 1000

const IdleTimerContainer = () => {
  const dispatch = useDispatch()
  const [loggedOutOpen, setLoggedOutOpen] = useState(false)

  const { accessToken }: any = useSelector<RootState>(({ auth }) => auth, shallowEqual)

  // Ref keeps onIdle closure in sync with current auth state
  const isLoggedInRef = useRef(!!accessToken)

  const logOut = () => {
    if (!isLoggedInRef.current) return
    dispatch(auth.actions.logout())
    setLoggedOutOpen(true)
  }

  const { activate } = useIdleTimer({
    timeout: IDLE_TIMEOUT_MS,
    crossTab: true,
    onIdle: logOut,
  })

  // Sync login state and reset idle timer so prior inactivity doesn't carry over on re-login
  useEffect(() => {
    isLoggedInRef.current = !!accessToken
    if (accessToken) activate()
  }, [accessToken]) // activate is stable from useIdleTimer; omitting it from deps is intentional

  return (
    <>
      {/* Already-logged-out notification modal */}
      <Modal
        open={loggedOutOpen}
        onClose={() => setLoggedOutOpen(false)}
        enforceFocus={false}
        size='xs'
      >
        <Modal.Body className='text-center'>
          <FiLogOut className='mb-3 text-danger' style={{ fontSize: '50px' }} />
          <h2 className='d-flex justify-content-center'>
            You have been logged out because you were inactive
          </h2>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default IdleTimerContainer
